import { getDynamoProvider } from './dynamo-client'

const dynamoProvider = getDynamoProvider({
  tableName: 'data',
  // bucket: 'test-bucket',
})

export default dynamoProvider
